export const GET_ASSET_BALANCE_REQUEST = 'GET_ASSET_BALANCE_REQUEST';
export const GET_ASSET_BALANCE_SUCCESS = 'GET_ASSET_BALANCE_SUCCESS';
export const GET_ASSET_BALANCE_FAILURE = 'GET_ASSET_BALANCE_FAILURE';

export const GET_IS_ADDRESS_APPROVED_ON_ASSET_REQUEST = 'GET_IS_ADDRESS_APPROVED_ON_ASSET_REQUEST';
export const GET_IS_ADDRESS_APPROVED_ON_ASSET_SUCCESS = 'GET_IS_ADDRESS_APPROVED_ON_ASSET_SUCCESS';
export const GET_IS_ADDRESS_APPROVED_ON_ASSET_FAILURE = 'GET_IS_ADDRESS_APPROVED_ON_ASSET_FAILURE';

export const APPROVE_ADDRESS_ON_ASSET_REQUEST = 'APPROVE_ADDRESS_ON_ASSET_REQUEST';
export const APPROVE_ADDRESS_ON_ASSET_SUCCESS = 'APPROVE_ADDRESS_ON_ASSET_SUCCESS';
export const APPROVE_ADDRESS_ON_ASSET_FAILURE = 'APPROVE_ADDRESS_ON_ASSET_FAILURE';

export const GET_ASSET_PRICE_REQUEST = 'GET_ASSET_PRICE_REQUEST';
export const GET_ASSET_PRICE_SUCCESS = 'GET_ASSET_PRICE_SUCCESS';
export const GET_ASSET_PRICE_FAILURE = 'GET_ASSET_PRICE_FAILURE';
